import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, User, Briefcase, Calendar } from 'lucide-react';

const IdeaCard = ({ idea }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Helper to format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div
      className="group relative bg-surface border border-white/5 rounded-2xl p-6 hover:border-primary/50 transition-all duration-300 hover:shadow-2xl hover:shadow-primary/10 hover:-translate-y-1 overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Background Gradient Effect */}
      <div className={`absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />

      <div className="relative z-10 flex flex-col h-full">
        {/* Header */}
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-xl font-bold font-display text-white group-hover:text-primary transition-colors duration-300 line-clamp-1">
              {idea.title}
            </h3>
            <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
              <span className="flex items-center gap-1">
                <User className="w-3 h-3" /> {idea.user.name}
              </span>
              <span>•</span>
              <span className="flex items-center gap-1">
                <Briefcase className="w-3 h-3" /> {idea.user.profession}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-1 bg-white/5 px-2 py-1 rounded-lg border border-white/10">
            <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
            <span className="text-sm font-bold text-white">
              {idea.average_rating ? Number(idea.average_rating).toFixed(1) : '0.0'}
            </span>
          </div>
        </div>

        {/* Content Preview */}
        <div className="space-y-3 mb-6 flex-grow">
          <div>
            <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Concept</h4>
            <p className="text-slate-300 text-sm line-clamp-3 leading-relaxed">
              {idea.description}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-auto pt-4 border-t border-white/5 flex items-center justify-between">
          <div className="flex items-center gap-1 text-xs text-slate-500">
            <Calendar className="w-3 h-3" />
            {formatDate(idea.created_at)}
          </div>

          <Link
            to={`/ideas/${idea.id}`}
            className="flex items-center gap-2 text-sm font-medium text-white group-hover:text-primary transition-colors"
          >
            Details
            <ArrowRight className={`w-4 h-4 transition-transform duration-300 ${isHovered ? 'translate-x-1' : ''}`} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default IdeaCard;
